import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, makeStyles, Typography, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";

const useStyles = makeStyles((theme) => ({
  boxContent: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexDirection: "column",
    alignItems: "start",
  },
  labelIn:{
    color:"#8DC13F",
    padding:'3px',
    marginRight:"5px",
    backgroundColor:"#8DC13F1A",
    borderRadius:"4px",
    textTransform:"upperCase"
  },
  labelOut:{
    color:"#b00020",
    padding:'3px',
    marginRight:"5px",
    backgroundColor:"#b000201A",
    borderRadius:"4px",
    textTransform:"upperCase"
  }
}));


const Modal = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    title,
    subTitle,
    children,
    onOk,
    onCancel,
    okDisabled,
    isOpen,
    punchIn,
    punchOut
  } = props;

  return (
    <Dialog open={isOpen} disableBackdropClick>
      {title && 
      <Grid container >
        <Grid item xs={6}>
        <DialogTitle style={{paddingBottom:'5px'}} id="form-dialog-title">
          {title}
        </DialogTitle>
        </Grid>
        <Grid item xs={6} style={{display:"flex",alignItems:"center",columnGap:"20px", padding:"16px 24px 4px 24px", color:"rgba(0, 0, 0, 0.54)"}}>
          <div>
          <Typography style={{fontSize:"14px"}}> <span className={classes.labelIn}>{properCase(t("pgReview.tableHeads.in"))}</span>  {punchIn}</Typography>
          </div>
          <div>
          <Typography style={{fontSize:"14px"}}> <span className={classes.labelOut}>{properCase(t("pgReview.tableHeads.out"))}</span>  {punchOut}</Typography>
          </div>
        </Grid>
      </Grid>}
      {subTitle && <DialogContent>
         <DialogContentText>{subTitle}</DialogContentText>
      </DialogContent>}
      <DialogContent className={classes.boxContent}>
        {children && children}
      </DialogContent>
      <DialogActions>
      <Button
          color="primary"
          variant="outlined"
          onClick={onCancel}          
        >
          {t("pgAddWorker.btnCancel")}
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onOk}   
          disabled={okDisabled?okDisabled:false}       
        >
          {t("pgAddWorker.btnSave")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// Specifies the default values for props:
Modal.defaultProps = {
  confirmDialog: {
    title: "pgPunch.tlConfirmation"
  },
};

Modal.propTypes = {
  title: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default Modal;
